import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { TranslocoDirective } from '@jsverse/transloco';

@Component({
    selector: 'success-message',
    templateUrl: './success-message.component.html',
    styleUrls: ['./success-message.component.scss'],
    imports: [TranslocoDirective]
})
export class SuccessMessageComponent implements AfterViewInit {
  @Input() id: string;
  @Input() message: string;
  @Input() goToLink: string;
  @Input() closeButton: boolean;
  @Output() triggerGoTo = new EventEmitter();
  @Output() canceled = new EventEmitter();
  @ViewChild('container') container: ElementRef<HTMLDivElement>;

  ngAfterViewInit(): void {
    this.container.nativeElement.focus();
  }

  goTo() {
    this.triggerGoTo.emit();
  }

  cancel() {
    this.canceled.emit();
  }
}
